import React from 'react';
import SpriteSVG from '@components/1-atoms/SpriteSVG';
import { CheckIcon, Chip, Label } from './OnboardingChip.styled';

export interface OnboardingChipProps {
  label: string;
  selected: boolean;
  onClick: () => void;
  dataTestId?: string;
}

/**
 * Onboarding-specific chip — wide rectangular pill with the label on the
 * left and a checkmark icon on the right when selected. Lives next to the
 * wizard rather than in the global atom library because it's deliberately
 * different from the generic Material `Chip` (small and pill-shaped).
 */
const OnboardingChip: React.FC<OnboardingChipProps> = ({
  label,
  selected,
  onClick,
  dataTestId,
}) => {
  return (
    <Chip
      type="button"
      role="checkbox"
      aria-checked={selected}
      data-testid={dataTestId}
      $selected={selected}
      onClick={onClick}
    >
      <Label>{label}</Label>
      {selected && (
        <CheckIcon aria-hidden="true">
          <SpriteSVG name="done_0" />
        </CheckIcon>
      )}
    </Chip>
  );
};

export default OnboardingChip;
